var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopExpenses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7917 29.1667H1.45833C0.652925 29.1667 0 28.5138 0 27.7083V1.45833C0 0.652925 0.652925 0 1.45833 0H24.7917C25.5971 0 26.25 0.652925 26.25 1.45833V27.7083C26.25 28.5138 25.5971 29.1667 24.7917 29.1667ZM7.29167 10.2083V13.125H18.9583V10.2083H7.29167ZM7.29167 16.0417V18.9583H18.9583V16.0417H7.29167Z",
    fill: "#F99049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopExpenses);
export default __webpack_public_path__ + "static/media/TopExpenses.23cbdbfc537390ca9d9e5b759ec5285f.svg";
export { ForwardRef as ReactComponent };